export default __webpack_public_path__ + "static/media/img-0170-spain-full-face.850e9edc.png";